import Amount from "@/models/Shared/Amount";
import FeeDefintionType from "./FeeDefinitionType";

export default class FeeDefinition {
    id: string = '';
    name: string = '';
    description: string = '';
    amount: Amount;
    type: FeeDefintionType = FeeDefintionType.Monthly;
    allowOverrideAmount: boolean = false;
}